import ReactPlayer from 'react-player';

const BloombergLive = () => {
     const handleError = (e) => {
    console.error('Error playing media:', e);
  };

  return (
    <div className="flex justify-center mt-10">
      <ReactPlayer
        url="https://liveprodusphoenixeast.akamaized.net/USPhx-HD/Channel-TX-USPhx-AWS-virginia-1/Source-USPhx-16k-1-s6lk2-BP-07-02-81ykIWnsMsg_live.m3u8"
        controls={true}
        width="100%"
        height="100%"
        onError={handleError}
      />
    </div>
  );
};

export default BloombergLive;
